import Link from "next/link";

const PeerquikCTA = () => {
  return (
    <div className="text-center py-6">
      <Link
        href="/register"
        className="inline-block bg-cyan-400 text-black font-bold text-lg px-6 py-3 rounded-lg hover:bg-cyan-300 transition-colors duration-200 hover:text-black"
        rel="nofollow"
      >
        Get your Peerquik boilerplate now!
      </Link>
    </div>
  );
};

export default PeerquikCTA;